<div class="d-flex w-100">
  <input [id]="input.MainElementList[0].ID" type="text" class="q-input-no-border col px-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input, 0)"
         (keyup)="getHour(input.MainElementList[0].Value)">
  <div class="col-auto">:</div>
  <input [id]="input.MainElementList[1].ID" type="text" class="q-input-no-border col px-0 ml-auto"
         [disabled]="input.MainElementList[1].Disabled"
         [(ngModel)]="input.MainElementList[1].Value"
         [ngClass]="setClass(input, 1)"
         (keyup)="getMin(input.MainElementList[1].Value)" />
  <div class="col-auto">:</div>
  <input [id]="input.MainElementList[2].ID" type="text" class="q-input-no-border col px-0 ml-auto"
         [disabled]="input.MainElementList[2].Disabled"
         [(ngModel)]="input.MainElementList[2].Value"
         [ngClass]="setClass(input, 2)"
         (keyup)="getSec(input.MainElementList[2].Value)" />
</div>
